import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import language from '../../../assets/languages/language';
import AppRoutes from '../../config/AppRoutes';
import Loader from '../../../common/loader';

class GMAT_QUESTION_BANK extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      chapters: [],
      token: '',
      lastRecord: '',
      lastAttempt: false,
      idname: '',
      freeChapterCount: [],
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = { router: React.PropTypes.object };

  toggleAlert() {
    this.setState({ alert_status: !this.state.alert_status });
  }

  _getReadings = chapter => {
    // console.log('chapterchapterchapterchapterchapterchapterchapter', chapter);
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', chapter.chapter_no),
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   chapter: chapter.chapter_no,
      //   chapterName: chapter.chapter_name,
      // },
    });
  };

  componentDidMount() {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(`${App_data.backend_api}/gmat_question_bank/getChapters`, data).then(async resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          chapters: resp.chapters,
          IRCount: resp.GMATIRTable,
          freeChapterCount: resp.freeChapterCount,
        });
        await FD.callAPI(
          `${App_data.backend_api}/gmat_question_bank/getlastAnsweredQuestion`,
          data,
        ).then(response => {
          if (response.success) {
            this.setState({
              lastRecord: response.data,
              lastAttempt: true,
            });
          }
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  goToQuestion = async () => {
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      this.context.router.push({
        pathname: AppRoutes.GMAT_QUESTION_BANK_VIEW_QUE.replace(
          ':notesid',
          lastRecord.gmat_question.chapter_id,
        )
          .replace(':readingid', lastRecord.gmat_question.reading_id)
          .replace(':id', lastRecord.gmat_question.id)
          .replace(':offset', 0),
      });
    }
  };
  render() {
    // console.log(language.LC())
    const countFree = this.state.freeChapterCount;
    const { lastAttempt } = this.state;
    let data = '';
    if (this.state.chapters.length && this.state.freeChapterCount.length) {
      data = this.state.chapters.map((item, index) =>
        countFree.map(itemFree =>
          item.chapter_no === itemFree.id ? (
            <div
              className='col-md-6 col-lg-6 col-xl-4 free-premium-section question_box'
              key={index}
            >
              <div
                className='question_bank_wrap pointer_class'
                key={item.id}
                // eslint-disable-next-line no-underscore-dangle
                onClick={this._getReadings.bind(this, item)}
              >
                <div className='margin_bottom_30'>
                  <img
                    src={`${App_data.frontend_url}/img/question_bank/icon2.svg`}
                    className=''
                    width='54'
                    alt=''
                  />
                </div>

                <div className='question_title' key={item.id} value={item.id}>
                  <a
                    className='pointer_class'
                    id={item.chapter_name}
                    value={item.chapter_no}
                    // eslint-disable-next-line no-underscore-dangle
                    onClick={this._getReadings.bind(this, item)}
                  >
                    {item.chapter_no}. {item.chapter_name}
                  </a>
                </div>

                <ul key={item.chapter_name}>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/free_reading_icon.svg`}
                        className=''
                        width='25'
                        alt=''
                      />
                    </span>
                    <span>{item.Countreading}</span>
                    <div className='tootip_box'>{language.LC().TOTAL_READINGS}</div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/free_question_icon.svg`}
                        className=''
                        width='26'
                        alt=''
                      />
                    </span>
                    <span>{itemFree.id !== 9 ? itemFree.count : this.state.IRCount}</span>
                    <div className='tootip_box'>{language.LC().FREE_QUESTIONS}</div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/premium_question_icon.svg`}
                        className=''
                        width='23'
                        alt=''
                      />
                    </span>
                    <span>{item.Countquestion}</span>
                    <div className='tootip_box'>{language.LC().PREMIUM_QUESTIONS}</div>
                  </li>
                </ul>
              </div>
            </div>
          ) : null,
        ),
      );
    } else {
      data = <Loader />;
    }
    return (
      <div className='animated fadeIn'>
        <div className='margin_bottom_20 d-flex justify-content-between last_question_read'>
          <h1 className='section_head'> {language.LC().CFA_LEVEL_I_QUESTION_BANK} </h1>

          {lastAttempt ? (
            <button
              className='btn btn-primary pointer_class'
              onClick={this.goToQuestion.bind(this)}
              disabled={!lastAttempt}
            >
              {' '}
              {language.LC().GO_TO_MY_LAST_QUESTION_ANSWERED}{' '}
            </button>
          ) : null}
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GMAT_QUESTION_BANK;



// WEBPACK FOOTER //
// ./src/views/GMAT/QuestionBank/QuestionBank.js